import { makeAutoObservable } from 'mobx';


export interface AlertDialogStoreProps {
  title: string;
  subtitle:  string ;
  onRightBtnPress?: () => void;
  rightBtnTxt?: string;
  onLeftBtnPress?: () => void;
  leftBtnTxt?: string;
  isSuccess: boolean;
  isFullScreen?:boolean
}
const INITIAL_PROPS_STATE: AlertDialogStoreProps = {
  title: '',
  subtitle: '',
  onRightBtnPress : () => {},
  rightBtnTxt: 'Continue',
  onLeftBtnPress: () => {},
  leftBtnTxt: 'Close',
  isSuccess: false,
  isFullScreen:false
};

/**
 * MobX store to manage the state and behavior of an alert dialog.
 */
class AlertDialogStore {
  isOpen: boolean = false;
  props: AlertDialogStoreProps = { ...INITIAL_PROPS_STATE };

  constructor() {
    makeAutoObservable(this);
  }

  /**
   * Opens the alert dialog with the specified properties.
   * @param props - The properties to apply to the alert dialog.
   * Default state of props:
   * - `title`: '' (empty string)
   * - `subtitle`: '' (empty string)
   * - `onRightBtnPress`: () => {} (no-op function)
   * - `rightBtnTxt`: 'Continue'
   * - `onLeftBtnPress`: () => {} (no-op function)
   * - `leftBtnTxt`: 'Close'
   * - `isFullScreen` :false
   * - `isSuccess`: false
   */
  open=(props: AlertDialogStoreProps) =>{
    this.isOpen = true;
    this.props = { ...INITIAL_PROPS_STATE, ...props }; 
  }

  /**
   * Closes the alert dialog and resets its properties to their default state.
   */
  close = () => {
    this.isOpen = false;
    this.props = { ...INITIAL_PROPS_STATE };
  }
}
export const alertDialogStore = new AlertDialogStore();
